/**
 * @packageDocumentation
 * @module api.functional.orders
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { CreatePreorderDto } from "../../structures/CreatePreorderDto";
import type { PaginationQueryisConfirmedbooleanundefinedisResolvedbooleanundefined } from "../../structures/PaginationQueryisConfirmedbooleanundefinedisResolvedbooleanundefined";
import type { ServiceResponsenull } from "../../structures/ServiceResponsenull";
import type { ServiceResponsePageOfPreorderundefined } from "../../structures/ServiceResponsePageOfPreorderundefined";
import type { ServiceResponsePreorderundefined } from "../../structures/ServiceResponsePreorderundefined";

export * as note from "./note/index";
export * as approve from "./approve/index";
export * as pending from "./pending/index";

/**
 * @controller PreorderController.deletePreorder
 * @path DELETE /orders/:id
 * @accessor api.functional.orders.deletePreorder
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function deletePreorder(
  connection: IConnection,
  id: string,
): Promise<deletePreorder.Output> {
  return PlainFetcher.fetch(connection, {
    ...deletePreorder.METADATA,
    template: deletePreorder.METADATA.path,
    path: deletePreorder.path(id),
  });
}
export namespace deletePreorder {
  export type Output = ServiceResponsenull;

  export const METADATA = {
    method: "DELETE",
    path: "/orders/:id",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (id: string) =>
    `/orders/${encodeURIComponent(id?.toString() ?? "null")}`;
}

/**
 * @controller PreorderController.getPreorders
 * @path GET /orders
 * @accessor api.functional.orders.getPreorders
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getPreorders(
  connection: IConnection,
  query: getPreorders.Query,
): Promise<getPreorders.Output> {
  return PlainFetcher.fetch(connection, {
    ...getPreorders.METADATA,
    template: getPreorders.METADATA.path,
    path: getPreorders.path(query),
  });
}
export namespace getPreorders {
  export type Query =
    PaginationQueryisConfirmedbooleanundefinedisResolvedbooleanundefined;
  export type Output = ServiceResponsePageOfPreorderundefined;

  export const METADATA = {
    method: "GET",
    path: "/orders",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (query: Query) => {
    const variables: URLSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(query as any))
      if (undefined === value) continue;
      else if (Array.isArray(value))
        value.forEach((elem: any) => variables.append(key, String(elem)));
      else variables.set(key, String(value));
    const location: string = "/orders";
    return 0 === variables.size
      ? location
      : `${location}?${variables.toString()}`;
  };
}

/**
 * @controller PreorderController.createPreorder
 * @path POST /orders
 * @accessor api.functional.orders.createPreorder
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function createPreorder(
  connection: IConnection,
  body: createPreorder.Body,
): Promise<createPreorder.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...createPreorder.METADATA,
      template: createPreorder.METADATA.path,
      path: createPreorder.path(),
    },
    body,
  );
}
export namespace createPreorder {
  export type Body = CreatePreorderDto;
  export type Output = ServiceResponsePreorderundefined;

  export const METADATA = {
    method: "POST",
    path: "/orders",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 201,
  } as const;

  export const path = () => "/orders";
}
